import { useIntl } from '@/intl'
import { space } from '@sunwebgroup/ui-components'
import {
  IconButton,
  Sheet,
  Typography,
} from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { styled } from 'styled-components'

const SheetContent = styled(Sheet.Content)`
  display: flex;
  flex-direction: column;
  gap: ${space('primitives_space_12')};
`

export function SortingExplanation({ className }: { className?: string }) {
  const intl = useIntl()

  return (
    <div className={className}>
      <Sheet.Root>
        <Sheet.Trigger>
          <IconButton variant="transparent-neutral" glyph="InformationInCircle" size="S" aria-label={intl.formatMessage({ id: 'sort_info_title' })} />
        </Sheet.Trigger>
        <Sheet.Body side="right" hasPadding bottomSideInMobile>
          <Sheet.Header closeLabel={intl.formatMessage({ id: 'close' })} titleLabel={intl.formatMessage({ id: 'sort_info_title' })} />
          <SheetContent>
            <Typography variant="body-l-bold-tight">
              {intl.formatMessage({ id: 'sort_info_popularity_title' })}
            </Typography>
            <Typography variant="body-m-regular-tight">
              {intl.formatMessage({
                id: 'sort_info_popularity_description',
              })}
            </Typography>
          </SheetContent>
        </Sheet.Body>
      </Sheet.Root>
    </div>
  )
}
